<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย" prop="namePromotion">
                            <el-input clearable v-model="form.promotion_name"></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อผู้ให้บริการ" prop="type">
                            <el-select
                              v-model="form.provider_id"
                              placeholder="โปรดเลือกชื่อผู้ให้บริการ"
                              :disabled="!!this.store_provider_id"
                            >
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option v-for="item in this.options" 
                              :label="item.provider_name" 
                              :key="item.id"  
                              :value="item.id"></el-option>
                            </el-select>
                            </el-form-item>
                          <el-form-item label="สถานะการให้บริการ" prop="status">
                            <el-select filterable v-model="form.service_status">
                              <el-option
                                label="ทั้งหมด"
                                value=""
                              ></el-option>
                              <el-option
                                label="เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)"
                                value="on sale"
                              ></el-option>
                              <el-option
                                label="ไม่ขายแล้วแต่ยังให้บริการ"
                                value="on service"
                              ></el-option>
                              <el-option label="ไม่มีการให้บริการ" value="out service"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทการให้บริการ" prop="provider_type">
                            <el-select 
                              filterable 
                              v-model="form.provider_type" 
                              placeholder="โปรดเลือกประเภทการให้บริการ"
                              @change="change_provider_type" 
                              :disabled="!!this.store_provider_type"
                            >
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option
                                label="อินเทอร์เน็ตความเร็วสูงประจำที่"
                                value="broadband"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลาในการนำส่งข้อมูล" style="table-layout:initial;">
                            <el-date-picker
                            style="width: 100%"
                              v-model="form.dateRange"
                              type="monthrange"
                              range-separator="-"
                              start-placeholder="เดือนเริ่มต้น"
                              end-placeholder="เดือนที่สิ้นสุด"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="ช่วงราคา (บาท)" class="slider_price">
                            <el-slider
                              v-model="form.priceRange"
                              :step="100"
                              range
                              :max="1600"
                              :show-input="true"
                              :show-stops="true"
                              :format-tooltip="changeTooltip"
                              :marks="{0:'0',100:'100',200:'200',300:'300',400:'400',500:'500',600:'600',700:'700',800:'800',900:'900',1000:'1000',1100:'1100',1200:'1200',1300:'1300',1400:'1400',1500:'1500',1600:'1500 ขึ้นไป'}"
                            ></el-slider>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="loadData">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>

              <!-- table -->
              <div class="table-responsive">
                <div class="box-body">
                  <template v-if="this.download_form!= null">
                    <div align="right" style="padding-bottom: 20px">
                      <el-button @click="get_download_data" type="primary">Export Excel</el-button>
                    </div>
                  </template>
                  <data-tables-server
                    @query-change="loadData"
                    :data="table_data"
                    :total="total"
                    :current-page.sync="form.page"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column sortable="custom" type="index" :index="index_method" prop="number" label="ลำดับ" width="90"></el-table-column>
                    <el-table-column prop="brand_name_th" label="ผู้ให้บริการ" width="100"></el-table-column>
                    <el-table-column
                      sortable
                      prop="promotion_code"
                      label="รหัสรายการส่งเสริมการขาย"
                      width="220"
                    ></el-table-column>
                    <el-table-column
                      sortable
                      prop="promotion_name_th"
                      label="ชื่อรายการส่งเสริมการขาย"
                      width="220"
                    ></el-table-column>
                    <el-table-column
                      sortable
                      prop="view_total"
                      label="จำนวนผู้เข้าชม"
                      width="140"
                    ></el-table-column>
                    <el-table-column sortable prop="promotion_technology" label="ประเภทของการให้บริการ" width="190"></el-table-column>
                    <el-table-column sortable prop="promotion_price" label="ราคา" width="100"></el-table-column>
                    <el-table-column sortable prop="start_sale_date" label="วันที่เริ่มขาย" width="200"></el-table-column>
                    <el-table-column sortable prop="end_sale_date" label="วันสิ้นสุดการขาย" width="200"></el-table-column>
                    <el-table-column sortable prop="start_service_date" label="วันที่เริ่มให้บริการ" width="200"></el-table-column>
                    <el-table-column sortable prop="end_service_date" label="วันสิ้นสุดการบริการ" width="200"></el-table-column>
                    <el-table-column sortable prop="status" label="สถานะ" width="200"></el-table-column>
                    <el-table-column sortable prop="updated_at" label="วันที่อัปเดตล่าสุด" width="150"></el-table-column>
                  </data-tables-server>
                  
                </div>
              </div>
            </div>
          </div>
      </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  created() {
    this.$store.dispatch('Manage_operator/getAvailableOperator')
    this.$store.dispatch('Report_view/get_provider_id')
    const regex = /Operator/;
    var currentPath = this.$router.currentRoute.path;
    if (regex.test(currentPath)) {
      this.form.isOper = true
    }
  },
  data() {
    return {
      page: 1,
      dialogVisible: false,
      label_position: "top",
      form: {
        isOper: false,
        promotion_name: "",
        provider_id: this.$cookies.get("user_nbtc").provider_id || "",
        provider_type: this.$cookies.get("user_nbtc").provider_type || "mobile",
        service_status: "",
        dateRange: "",
        priceRange: [0, 1600]
      },
      dialogFormVisible: false,
      tableProps: {
        border: true
        // stripe: true,
      },
      tableProps: {
        border: true,
        stripe: true,
        defaultSort: {
          prop: "flow_no",
          order: "descending"
        }
      },
      options : []
    };
  },
  mounted(){},
  computed: {
    ...mapState({
      store_provider_id : store => store.Report_view.provider_id,
      store_provider_type : store => store.Report_view.provider_type,
      table_data : store => store.Report_view.lists,
      total : store => store.Report_view.total,
      details : store => store.Report_view.details,
      date_range: store => store.Report_view.date,
      provider_list : store=> store.Manage_operator.select_lists,
      loading : store => store.Report_view.loading,
      download_form : store => store.Report_view.download_form
    })
  },
  watch : {
    provider_list : {
      handler : function(reload, empty){
        this.options = reload
        if(this.$cookies.get('user_nbtc').provider_id == null){
          this.options = reload.filter(item => item.provider_type == this.form.provider_type)
        }
        this.form.provider_id = this.$cookies.get('user_nbtc').provider_id != null ? this.$cookies.get('user_nbtc').provider_id : ''
      }
    },
    store_provider_type : {
      handler : function(reload, empty){
        this.form.provider_type = reload
      }
    },
    store_provider_id : {
      handler : function(reload, empty){
        this.form.provider_id = reload
      }
    }
  },
  methods: {
    ...mapActions({
      search: "Report_view/getTotalView",
      getOperator: "LisetOperator/fetch_table",
      setDateRange: "Report_view/setDateRange",
      download : 'Report_view/download_promotion'
    }),
    get_download_data() {
      this.download(this.download_form)
    },
    loadData(queryInfo) {
      if (queryInfo) {
        if(queryInfo.type == 'sort'){
          this.form.sort = {
            prop: queryInfo.sort.prop,
            order: queryInfo.sort.order
          }
        } 
        this.form.page = queryInfo.page || 1;
        this.form.pageSize = queryInfo.pageSize || 10;
        this.search(this.form)
        setTimeout(() => {
          this.data = this.table_data
        }, 500);
      } else {
        this.page = 1
        this.form.page = queryInfo.page || 1;
        this.form.pageSize = queryInfo.pageSize || 10;
        this.search(this.form)
        setTimeout(() => {
          this.data = this.table_data
        }, 500);
      }
    },
    change_provider_type(){
      this.options = this.provider_list.filter(item => item.provider_type == this.form.provider_type) 
    },
    index_method(index) {
      return index + (this.form.pageSize * (this.form.page - 1)) + 1
    },
    handleClose(done) {
      done();
    },
    changeTooltip(value) {
      if (value == 1600) {
        return "1500 ขึ้นไป";
      }
      return value;
    }
  }
};
</script>
